import { ICartViewModel } from '@/@types/client-api';
import { formatNumber } from '@/utils/helpers';

interface IMembershipSavingsProps {
  cart?: ICartViewModel;
}
export const MemberSavingsText = ({ cart }: IMembershipSavingsProps) => {
  if (!cart) {
    return null;
  }

  const programsContractDiscount = cart?.programsMembershipDiscountValue ?? 0;
  const publicationsContractDiscount = cart?.publicationsMembershipDiscountValue ?? 0;
  const overallMembershipDiscount = cart?.membershipDiscountValue ?? 0;

  if (programsContractDiscount > 0 && publicationsContractDiscount > 0) {
    return (
      <p>
        You are saving{' '}
        <span className="text-red">${formatNumber(overallMembershipDiscount ?? 0)}</span> with your
        PLI Membership with PLUS
      </p>
    );
  } else if (programsContractDiscount > 0) {
    return (
      <p>
        You are saving{' '}
        <span className="text-red">${formatNumber(programsContractDiscount ?? 0)}</span> with a PLI
        Membership
      </p>
    );
  } else if (publicationsContractDiscount > 0) {
    return (
      <p>
        You are saving{' '}
        <span className="text-red">${formatNumber(publicationsContractDiscount ?? 0)}</span> with
        your PLI PLUS Subscription
      </p>
    );
  }

  return null;
};
